/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminlogin1Inputs */

const en_adminlogin1 = /** @type {(inputs: Adminlogin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin Login`)
};

const de_adminlogin1 = /** @type {(inputs: Adminlogin1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Anmeldung`)
};

/**
* | output |
* | --- |
* | "Admin Login" |
*
* @param {Adminlogin1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const adminlogin1 = /** @type {((inputs?: Adminlogin1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminlogin1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_adminlogin1(inputs)
	return de_adminlogin1(inputs)
});
export { adminlogin1 as "adminLogin" }